<template>

    <b-modal id="bv-new-message" size="lg" hide-footer>
      <template #modal-title>Message to {{ display_name }}</template>

      <div class="row">
        <div class="col">
            <textarea
                class="form-control shadow-none inputbox" 
                placeholder="Write message here"
                rows="5"
                v-model="content"></textarea>
        </div>
      </div>

      <div class="row pt-3 pb-2">
        <div class="col">
                  <div>
<button v-if="updating" type="button" class="btn btn-success submit col">
  <i class="fas fa-spinner fa-sm fa-spin mr-2 move-up"></i></button>
        <button v-else type="button" class="btn btn-danger submit col" @click="sendMessage">Send</button>
      </div>
        </div>
      </div>

    </b-modal>

</template> 

<script>
export default {

  props: ['projectInfo', 'receiver_id', 'display_name'],

  data() {
    return {
      updating: false,
      content: null,
    };
  },

  methods: {

    hideNewMessageModal() {
      this.$bvModal.hide('bv-new-message');
    },

    sendMessage() {

        if (this.content == null || this.content == '') {this.sweetfire('Please write a message')}

        else {

          this.updating = true;

          axios
          .post('/messages/send', {
            receiver_id: this.receiver_id,
            project_id: this.projectInfo.id,
            message: this.content,
            url: '/projects/view/' + this.projectInfo.id+'/0',
          })
          .then((response) => {

          if (response.data.success) {
            this.hideNewMessageModal();
            this.showToaster('Message sent');
            this.content = null;
          } else {
            this.sweetfire(response.data.message);
          }
          
          this.updating = false;

        });

        }

      },

      showToaster(text) {
      this.$toaster.success(text, { timeout: 2500 });
      },

      sweetfire(text) {

      Swal.fire({
      title: text,
      showConfirmButton: false,
      showDenyButton: false,
      showCancelButton: true,
      focusConfirm: false,
      cancelButtonText: 'Ok',
      customClass: { title: "popup-title" },
    })

    },
  },
};
</script>

<style scoped>
.btn {border-radius:5px !important;}
</style>